// extracted by mini-css-extract-plugin
module.exports = {"Signup":"Signup_Signup__2e5-8","Link":"Signup_Link__2b9e7"};